import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQBRKeyOptions = createSelector(
  [selectQbrState],
  (state) => state.selectedDocument?.KeyPoints
)
